import Model, { ID, Integer, MODEL_LEVEL } from 'src/models/Model'

export default class Studio extends Model {
  static name = 'Studio'

  static deletable = true
  static duplicatable = true
  static filterable = true
  static paginate = true
  static versioned = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.StudioReporting]

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true
      },
      name: {
        type: String,
        default: '',
        reference: true,
        sortable: true
      },
      abbreviation: {
        type: String,
        computed () {
          if (this.isRemote) return this.data.abbreviation

          return _.toUpper(this.name.replace(/\W/g, '').substring(0, 4), 4)
        }
      },
      boxOfficeWeekDefaultStartDay: {
        type: Integer,
        default: 5 // Friday
      },
      boxOfficeWeekDefaultExtendPremieres: {
        type: Boolean,
        default: false
      },
      sendRentrak: {
        type: Boolean,
        default: false
      },
      reportByEmail: {
        type: Boolean,
        default: false
      },
      autoSendEmail: {
        type: Boolean,
        default: false
      },
      useEmailSummary: {
        type: Boolean,
        default: false
      },
      reportBoxOfficeDaily: {
        type: Boolean,
        default: false
      },
      showRentalReporting: {
        type: Boolean,
        default: true
      },
      showIndividualBoxOfficeReporting: {
        type: Boolean,
        default: true
      },
      hasRetentionFee: {
        type: Boolean,
        default: false
      },
      retentionFeePercentHundredths: {
        type: Integer,
        default: 0
      },
      reportingEmail: {
        type: String,
        reference: true
      },
      reportBySwiftEbor: {
        type: Boolean,
        default: false
      },
      autoSendSwiftEbor: {
        type: Boolean,
        default: false
      },

      libraryParentId: {
        type: ID,
        output: true,
        excludeFromDefault: true
      },
      receiveLibraryUpdates: {
        type: Boolean,
        excludeFromDefault: true
      }
    }
  }
}
